export default "__VITE_ASSET__BHK7XDzQ__"